import http from "./request"

export const getSiteList = () => http.get("/manage/front/site/list")

export const sendSmsCode = data => http.post("/manage/front/login/sendCode", data)
export const loginByCode = data => http.post("/manage/front/login/byCode", data)
export const getUserProfile = () => http.get("/manage/front/user/profile")
export const getDictData = params => http.get("/manage/front/dict/data/list", { params })

export const getCategoryList = params => http.get("/manage/front/category/list/bySiteId", { params })
export const getCategoryByName = params => http.get("/manage/front/category/list/bySiteIdAndName", { params })
export const getCategoryColumns = params => http.get("/manage/front/category/list/column", { params })

function withPageParams(data) {
  return {
    params: {
      pageNum: (data && data.pageNum) || 1,
      pageSize: (data && data.pageSize) || 10
    }
  }
}

export const getFormList = data => http.post("/manage/front/form/business/query/list", data, {
  ...withPageParams(data),
  timeout: 60000
})
export const getFormListByService = data => http.post("/manage/front/form/business/query/listByServiceId", data, {
  ...withPageParams(data),
  timeout: 30000
})
export const searchFormList = data => http.post("/manage/front/form/business/query/list", data)
export const getFormDetail = data => http.post("/manage/front/form/business/queryById", data)

export const getSearchHistory = () => http.get("/manage/front/search-history/list")
export const getHotSearch = () => http.get("/manage/front/search-history/hot")
export const deleteSearchHistory = data => http.post("/manage/front/search-history/delete", data)
export const getViewCountSum = params => http.get("/manage/front/search-history/view-count-sum", { params })

export const getEnterpriseCarousel = params => http.get("/manage/front/famous/enterprise/carousel/list", { params })
export const getFamousEnterpriseClass = () => http.get("/manage/front/famous/enterprise/class/list")
export const getEnterpriseInfo = params => http.get("/manage/front/user/enterprise/info/byId", { params })
export const getEnterpriseJobs = params => http.get("/manage/front/form/business/enterprise/recruitingPositions", { params })
export const getEnterpriseOther = params => http.get("/manage/front/form/business/enterprise/otherInfo", { params })
export const getUserInfoById = params => http.get("/manage/front/user/info/byId", { params })
export const getPersonalOther = params => http.get("/manage/front/form/business/personal/otherInfo", { params })

export const getAreaList = params => http.get("/manage/front/area/list", { params })
export const getAllProvince = () => http.get("/manage/front/area/all/province")
export const getAreaRegion2 = params => http.get("/manage/front/area/region2", { params })
export const getDefaultCondition = params => http.get("/manage/front/form/config/default/condition", { params })
export const getCategoryCondition = params => http.get("/manage/front/form/config/category/condition", { params })
export const getAllCondition = params => http.get("/manage/front/form/config/all/condition", { params })
export const getFormConfigByService = params => http.get("/manage/front/form/config/list/byServiceCategoryId", { params })

export const getCarouselList = params => http.get("/manage/front/carousel/list", { params })
export const getWechatQr = () => http.get("/manage/front/form/business/wechat/qr")

export const getPhoneBookList = params => http.get("/manage/front/phone/book/list", { params })
export const getPhoneBookRecords = params => http.get("/manage/front/phone/book/record/list", { params })
export const addPhoneRecord = data => http.post("/manage/front/phoneRecord/add", data)

export const getLuckMoneyList = data => http.post("/manage/front/form/business/luckMoney/data/list", data)
export const grabLuckMoney = params => http.get("/manage/front/luckMoney/grab/luckMoney", { params })
export const getLuckMoneyDetail = params => http.get("/manage/front/luckMoney/detail", { params })

export const getWechatClassList = () => http.get("/manage/front/wechat/type/class/list")
export const getOfficialClassList = () => http.get("/manage/front/official/account/type/class/list")
export const getWechatGroupList = data => http.post("/manage/front/form/business/wechat/group/list", data)
export const getOfficialAccountList = data => http.post("/manage/front/form/business/official/account/list", data)

export const getNewsCarousel = () => http.get("/manage/front/news/carousel/list")
export const getNewsClassList = () => http.get("/manage/front/system/newsClass/list")
export const getNewsDetail = params => http.get("/manage/front/system/news/detail", { params })

export const getHelpCenter = () => http.get("/manage/front/help/center/detail")

export const consumeViewPoint = data => http.post("/manage/front/buy/point/consume", data)
export const cvViewPrecheck = params => http.get("/manage/front/buy/cvViewPrecheck", { params })
export const cvPointConsume = data => http.post("/manage/front/buy/cvPointConsume", data)
export const getMySimpleResume = () => http.get("/manage/front/cv/my/simple")
export const useCvPoint = params => http.get("/manage/front/cv/point/use/use", { params })
export const deliverResume = params => http.get("/manage/front/cv/enterprise/delivery", { params })

export const submitComplaint = data => http.post("/manage/front/system/complaint", data)
export const toggleCollect = params => http.get("/manage/front/collect/add", { params })
export const addBlack = params => http.get("/manage/front/black/add", { params })
export const deleteBlack = params => http.get("/manage/front/black/delete", { params })

export const getAdverImages = (params, skipSiteId = true) => http.get("/manage/front/form/business/adver/images", { params, skipSiteId })
export const getRescueImages = params => http.get("/manage/front/form/business/imageRescues/images", { params })
export const getCustomerServiceQrList = params => http.get("/manage/front/customer/service/qr/list", { params })
export const getRealEstateAgency = params => http.get("/manage/front/form/business/realEstateAgency", { params })
export const getPropertySettled = () => http.get("/manage/front/form/business/list/propertySettled")
export const getMarketList = params => http.get("/manage/front/market/distribution/list", { params })
export const getMarketRecords = params => http.get("/manage/front/market/distribution/record/list", { params })

export function unwrapList(res) {
  if (!res) return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.rows)) return res.rows
  if (Array.isArray(res.data)) return res.data
  if (res.data && Array.isArray(res.data.rows)) return res.data.rows
  if (res.data && Array.isArray(res.data.data)) return res.data.data
  return []
}

export function unwrapData(res) {
  if (!res) return null
  if (res.data !== undefined) return res.data
  return res
}
